import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BankProposalValuationTaskService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subDomainService: SubdomainService
  ) {}

  updateValuationTask(id: number, payload: {
    is_new_task: boolean
    base_of_value_id: number,
    premise_of_value_id: number,
    approach_to_value_id: number,
    method_to_value_id: number,
    tenure_id: number,
    consideration_type_id: number
  }) {
    return this.http.put(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/valuation-task/${id}`,
      {
        payload
      },
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }
}